import { MethodDto } from 'src/store/methods/method';
import { ArrayUtils } from 'src/utils/array';
import { MethodAction, MethodTypes } from './methods.actions';

export type MethodsState = Readonly<{
  methods: MethodDto[];
  errors: any;
}>;

const initialState: MethodsState = {
  methods: [],
  errors: null
};

const methodsReducer = (
  state: MethodsState = initialState,
  action: MethodAction
) => {
  switch (action.type) {
    case MethodTypes.FetchAll:
      return { ...state, methods: action.methods };
    case MethodTypes.Add:
      return { ...state, methods: [...state.methods, action.method] };
    case MethodTypes.Update:
      return {
        ...state,
        methods: ArrayUtils.updateListById(state.methods, action.method)
      };
    case MethodTypes.Delete:
      return {
        ...state,
        method: null,
        methods: ArrayUtils.deleteFromListById(state.methods, action.method)
      };
    case MethodTypes.Failure:
      return { ...state, errors: action.errors };
    default:
      return state;
  }
};

export default methodsReducer;
